require('./index.jade')
moment = require('moment')
$ = require('jquery')

GroupMemPermissionDirective = ($filter ,$translate ) ->
  restrict: "EA"
  replace: true
  templateUrl: "group-member/group-mem-permission-directive/index.jade"
  scope:
    data: '=data'
    permissionData: '=perData'
    userid: '=userId'
  link: (scope) ->
    scope.displayName = (fName , lName) ->
      fName = fName ? ''
      lName = lName ? ''
      if fName + lName == ''
        return $filter('translate')('_RANKING_GROUP.EVENT_RANK.UNNAMED')
      if /^ja/i.test $translate.preferredLanguage()
        return lName + " " + fName
      return fName + " " + lName

    scope.changePermission = (data , permission) ->
      if data.role == permission.value
        data.newPermission = ''
        return
      data.newPermission = permission.value
    scope.displayStatus = (data , stage) ->
      if stage != ""
        return data.newPermission == stage
      return data.newPermission && data.newPermission != 'delete' && data.newPermission != data.role

    scope.getTextOfAvatar = ->
      $avatarElement = $(".avatar-for-#{scope.data.id} .avatar-image-text:not(.is-small)")

      if scope.data.display_text_avatar.length == 1
        $avatarElement.removeClass('two-characters')
        $avatarElement.addClass('one-character')
      else
        $avatarElement.removeClass('one-character')
        $avatarElement.addClass('two-characters')
      scope.data.display_text_avatar

    scope.isAvatarColor = ->
      scope.data.avatar_image_path?.indexOf('avatar_color') > -1

GroupMemPermissionDirective.$inject = [
  '$filter'
  '$translate'
]

module.exports = GroupMemPermissionDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-member/group-mem-permission-directive/group-mem-permission-directive.coffee